// The current API uses the legacy `sms` wire value for Workday app push messages.
// Keep that value at the boundary while presenting Workday app as the only channel.
export const WORKDAY_APP_CHANNEL_KEY = "sms";
export const WORKDAY_APP_CHANNEL_LABEL = "Workday app";
export const WORKDAY_APP_CHANNEL = {
  key: WORKDAY_APP_CHANNEL_KEY,
  label: WORKDAY_APP_CHANNEL_LABEL,
};

export function templateSupportsWorkdayApp(template) {
  if (template.pushEnabled !== undefined) return template.pushEnabled;
  return template.channel === WORKDAY_APP_CHANNEL_KEY || template.channel === "workday";
}

export function normalizeWorkdayAppPlan(plan = []) {
  return plan.map((touch) => ({ ...touch, channel: WORKDAY_APP_CHANNEL_KEY }));
}

export function displayChannelLabel(channel, enums) {
  if (channel === WORKDAY_APP_CHANNEL_KEY || channel === "workday") {
    return WORKDAY_APP_CHANNEL_LABEL;
  }
  return enums?.channels?.find((item) => item.key === channel)?.label || channel;
}
